// @flow
import type { Dispatch } from "redux"

import { setPriorityBoardingData } from "./services/priorityBoarding/actions"
import type { AdditionalServicesInput } from "booking/services/additionalServices/types"

export const setAdditionalServices = (additionalServices: AdditionalServicesInput) => (
  dispatch: Dispatch<any>,
) => {
  if (additionalServices.priority_boarding) {
    dispatch(setPriorityBoardingData(additionalServices.priority_boarding))
  }
}
